import dosBg from '../../assets/images/dos-bg.png';
import dos from '../../assets/images/dos.png';
import dosMobile from '../../assets/images/dosMobile.png';
import shoshartBg from '../../assets/images/shoshart-bg.png';
import shoshart from '../../assets/images/shoshart.png';
import shoshartMobile from '../../assets/images/shoshartMobile.png';
import talawBg from '../../assets/images/talaw-bg.jpg';
import talaw from '../../assets/images/talaw.png';
import talawMobile from '../../assets/images/talawMobile.png';
import tamkaZenBg from '../../assets/images/tamkaZen-bg.png';
import tamkaZen from '../../assets/images/tamkaZen.png';
import stringTheoryBg from '../../assets/images/stringTheory-bg.png';
import stringTheory from '../../assets/images/stringTheory.png';
import cadrBg from '../../assets/images/cadr-bg.png';
import cadr from '../../assets/images/cadr.png';
import cadrMobile from '../../assets/images/cadrMobile.png';
import mathBg from '../../assets/images/math-bg.png';
import math from '../../assets/images/math.png';
import mathMobile from '../../assets/images/mathMobile.png';
import jewkuleleBg from '../../assets/images/jewkulele-bg.png';
import jewkulele from '../../assets/images/jewkulele.png';
import jewkuleleMobile from '../../assets/images/jewkuleleMobile.png';
import padlaotBg from '../../assets/images/padlaot-bg.png';
import padlaotMobile from '../../assets/images/padlaotMobile.png';

export const data = [
    {
        title: 'dosgamesworld.com',
        link: 'https://dosgamesworld.com',
        bg: dosBg,
        desktop: dos,
        mobile: dosMobile,
        description: 'A site dedicated to vintage Dos (and some non-Dos) games. Built with a friend during the long Corona quarantine. Created with Angular.'
    },
    {
        title: 'Artist Portfolio',
        link: 'https://shoshiart.netlify.app/',
        bg: shoshartBg,
        desktop: shoshart,
        mobile: shoshartMobile,
        description: 'An artist portfolio site built with Next.js and deployed with Netlify. Decap CMS was added to the project to allow the artist to manage the content.'
    },
    {
        title: 'Tamka Zen',
        link: 'https://chromewebstore.google.com/detail/tamka-zen/idjhpefifgenjhecejdnobchjojibgoi',
        bg: tamkaZenBg,
        desktop: tamkaZen,
        mobile: '',
        description: 'A chrome extension that allows you to block distracting on a news site called Ynet. Developed using vanilla JavaScript, HTML5, and Chrome Extension APIs.'
    }, 
    {
        title: 'Lawyer website',
        link: 'https://talaw.netlify.app/',
        bg: talawBg,
        desktop: talaw,
        mobile: talawMobile,
        description: 'A lawyer site built with Nuxt and deployed with Netlify. Decap CMS was added to allow the lawyer to manage the content.'
    },
    {
        title: 'String Theory',
        link: 'https://github.com/Yarden84/string-theory?tab=readme-ov-file',
        bg: stringTheoryBg,
        desktop: stringTheory,
        mobile: '',
        description: 'A Chord / Scale Engine for any string instrument imaginable! Created with React using Cursor AI.'
    },
    {
        title: 'cadr.co.il',
        link: '',
        bg: cadrBg,
        desktop: cadr,
        mobile: cadrMobile,
        description: 'A site made for the Center of Arbitration and Dispute Resolution. Created via WordPress, with a custom theme developed from scratch according to a studio design. '
    },
    {
        title: 'Understand Math',
        link: 'https://github.com/Yarden84/Math-Project',
        bg: mathBg,
        desktop: math,
        mobile: mathMobile,
        description: 'Interactive educational website, made according to a book written by the late Israel Haizler. This version is a POC, and hopefully a more extensive version will be ready soon.'
    },
    {
        title: 'Jewkulele',
        link: 'https://github.com/Yarden84/Uke-Project',
        bg: jewkuleleBg,
        desktop: jewkulele,
        mobile: jewkuleleMobile,
        description: 'A site dedicated to a small passion of mine - the ukulele! This site contains information about the instrument, a chord engine, tuner and more. Created with Anguler.'
    },
    {
        title: 'Padlaot',
        link: 'https://github.com/Yarden84/Padlaot',
        bg: padlaotBg,
        mobile: padlaotMobile,
        description: 'A scoreboard for amateur soccer games. Created with Angular and deployed with Heroku.'
    },
]